import { styled } from "@mui/material/styles";

interface StyledSearchProps {
  error?: boolean;
}
// eslint-disable-next-line no-empty-pattern
const StyledSearch = styled("div", {shouldForwardProp: (prop) => prop !== "error"})<StyledSearchProps>(({theme, error}) => ({
  position: "relative",
  paddingRight: 24,
  borderBottom: `2px solid ${error ? "red" : "#adb5bd"}`,
  "&:hover": {
    borderBottomColor: error ? "red" : "#6c757d",
  },
  "&:focus-within": {
    borderBottomColor: error ? "red" : "#495057",
    boxShadow: error ? "0 1px 0 red" : "0 1px 0 #495057",
  },
  marginLeft: 0,
  width: "100%",
}));

export default StyledSearch;
